const initialState = {
  categories: [],
  products: [],
  cart: [],
  activeCategory: null
};

const gamesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'Products/SET_ACTIVE_CATEGORY':
      return {
        ...state,
        activeCategory: action.payload
      };
    case 'Products/SET_CATEGORIES':
      return {
        ...state,
        categories: action.payload
      };
    case 'Products/SET_PRODUCTS':
      return {
        ...state,
        products: action.payload
      };
    case 'Cart/SET':
      return {
        ...state,
        cart: action.payload
      };
    case 'Cart/ADD': {
      const id = action.payload.id;
      const newCart = [...state.cart];
      if (newCart.find((item) => item.id === id)) {
        newCart.map((item) => {
          if (item.id === id) {
            item.quantity += action.payload.quantity;
          }
          return item;
        });
      } else {
        newCart.push(action.payload);
      }

      return {
        ...state,
        cart: newCart
      };
    }
    case 'Cart/REMOVE': {
      const id = action.payload;
      return {
        ...state,
        cart: state.cart.filter((item) => item.id !== id)
      };
    }
    case 'Cart/SET_QUANTITY': {
      if (state.cart.length === 0) return state;
      const { id, quantity } = action.payload;
      return {
        ...state,
        cart: state.cart.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              quantity
            };
          }
          return item;
        })
      };
    }

    case 'Cart/RESET': {
      return {
        ...state,
        cart: []
      };
    }

    default:
      return state;
  }
};

export default gamesReducer;
